import type { ReactNode } from "react";
import * as React from "react";

interface ICardValueProps {
  children: ReactNode;
}

export function CardValue({
  children,
  ...props
}: ICardValueProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) {
  return (
    <h1 className="m-0 font-aeonik text-2xl font-bold" {...props}>
      {children}
    </h1>
  );
}

interface ICardDescriptionProps {
  children: ReactNode;
}

export function CardDescription({ children }: ICardDescriptionProps) {
  return <span className="flex font-aeonik text-sm font-medium text-gray-500">{children}</span>;
}

interface IIconCardProps {
  primaryColor: string;
  secondaryColor: string;
  icon: ReactNode;
  children: ReactNode;
}

export default function IconCard({ primaryColor, secondaryColor, icon, children }: IIconCardProps) {
  return (
    <div className="relative flex w-full flex-col rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div
        className="mb-4 flex h-7 w-7 items-center justify-center rounded-lg squircle"
        style={{
          color: primaryColor,
          backgroundColor: secondaryColor,
        }}
      >
        {icon}
      </div>

      <div className="mt-auto">{children}</div>
    </div>
  );
}
